import styled from "styled-components";

export const StyledRefundDetails = styled.div`
  margin: 1rem 0px 0px;
  padding: 1rem;
  background: var(--rms-v2-surface);
  border: 1px solid var(--rms-v2-border-soft);
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.05);
  border-radius: ${(props) => (props.roundedEdgeButtons ? "10px" : "0px")};

  .refund-details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .refund-amount {
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .refund-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .refund-title {
    display: flex;
    align-items: center;
  }

  .refund-time {
    font-size: 10px;
    text-align: right;
    display: flex;
    gap: 2px;
  }

  .refund-mode {
    text-transform: capitalize;
    display: flex;
    align-items: center;
    font-size: 10px;

    span {
      margin-top: 2px;
      margin-left: 4px;
    }
  }

  .refund-detail-grid {
    border-top: 1px solid var(--rms-v2-border-soft);
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 14px;
    padding-top: 14px;
  }

  .refund-detail-cell {
    min-width: 0;
  }

  .refund-detail-cell.wide {
    grid-column: 1 / -1;
  }

  .refund-detail-label {
    color: var(--rms-v2-text-muted);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.6px;
    margin: 0 0 6px;
    text-transform: uppercase;
  }

  .refund-detail-value-row {
    align-items: center;
    display: flex;
    gap: 6px;
    min-width: 0;
  }

  .refund-detail-value-row > .refund-icon,
  .refund-detail-value-row > svg {
    color: var(--rms-v2-text-muted);
    flex: 0 0 auto;
    height: 16px;
    width: 16px;
  }

  .refund-detail-value {
    color: var(--rms-v2-text-body);
    font-size: 13px;
    font-weight: 700;
    line-height: 1.35;
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .refund-copy-button {
    align-items: center;
    background: transparent;
    border: 0;
    color: ${(props) => props.primary_color || "var(--rms-v2-primary)"};
    cursor: pointer;
    display: inline-flex;
    flex: 0 0 auto;
    justify-content: center;
    padding: 2px;
  }

  .refund-copy-button svg {
    height: 15px;
    width: 15px;
  }

  .refund-copy-button.copied {
    color: var(--rms-v2-success);
  }

  .refund-detail-pending-message {
    border-top: 1px solid var(--rms-v2-border-soft);
    color: var(--rms-v2-text-muted);
    font-size: 12px;
    font-weight: 700;
    line-height: 1.4;
    margin: 14px 0 0;
    padding-top: 12px;
  }

  .refund-icon.gift-card {
    font-size: 20px;
  }

  .refund-icon.upi,
  .refund-icon.source {
    font-size: 14px;
  }

  .refund-icon.bank,
  .refund-icon.coupon,
  .refund-icon.wallet {
    font-size: 18px;
  }

  .refund-status {
    font-size: 9px;
    text-transform: capitalize;
    margin-left: 10px;
    padding: 0px 5px;
    border-radius: ${(props) => (props.roundedEdgeButtons ? "5px" : "0px")};
    background: ${(props) =>
      props?.refundStatus?.includes("completed") ||
      props?.refundStatus?.includes("processed") ||
      props?.refundStatus?.includes("redeemed") ||
      props?.refundStatus?.includes("paid")
        ? "var(--rms-v2-success-soft)"
        : props?.refundStatus?.includes("fail") ||
          props?.refundStatus?.includes("expired") ||
          props?.refundStatus?.includes("cancelled") ||
          props?.refundStatus?.includes("deactivate") ||
          props?.refundStatus?.includes("reversal")
        ? "var(--rms-v2-danger-soft)"
        : "#d9eafe"};
    color: ${(props) =>
      props?.refundStatus?.includes("completed") ||
      props?.refundStatus?.includes("processed") ||
      props?.refundStatus?.includes("redeemed") ||
      props?.refundStatus?.includes("paid")
        ? "var(--rms-v2-success)"
        : props?.refundStatus?.includes("fail") ||
          props?.refundStatus?.includes("expired") ||
          props?.refundStatus?.includes("cancelled") ||
          props?.refundStatus?.includes("deactivate") ||
          props?.refundStatus?.includes("reversal")
        ? "var(--rms-v2-danger)"
        : "#4273EB"};
  }

  .account-details {
    font-size: 12px;
  }

  .account-detail-value {
    font-weight: 600;
  }

  .claim-refund-link {
    color: inherit;
  }

  .claim-refund-action {
    margin-top: 14px;
  }

  .refund-details-error {
    color: var(--rms-v2-danger);
    font-size: 13px;
    font-weight: 700;
    margin-top: 12px;
  }

  hr {
    margin: 6px 0px;
  }

  button {
    font-size: 12px;
  }

  .payment-method-card {
    background: var(--rms-v2-surface);
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.roundedEdgeButtons ? "10px" : "0px")};
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 10px;
    padding: 14px;
    width: 100%;
  }

  .payment-method-title {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 700;
    margin: 0;
  }

  .payment-method-options {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .payment-method-option {
    align-items: center;
    background: var(--rms-v2-surface-muted);
    border: 1px solid var(--rms-v2-border);
    border-radius: ${(props) => (props.roundedEdgeButtons ? "10px" : "0px")};
    color: var(--rms-v2-text-title);
    cursor: pointer;
    display: flex;
    font: inherit;
    font-size: 13px;
    font-weight: 700;
    gap: 10px;
    min-height: 44px;
    padding: 10px 12px;
    text-align: left;
  }

  .payment-method-option.selected {
    background: ${(props) => `${props.primary_color || "var(--rms-v2-primary)"}08`};
    border-color: ${(props) => props.primary_color || "var(--rms-v2-primary)"};
  }

  .payment-method-check {
    flex: 0 0 18px;
  }

`;

export const StyledRefundDetailsDrawer = styled.div`
  background: var(--rms-v2-section-bg);
  color: var(--rms-v2-text-body);
  max-height: min(82vh, 720px);
  overflow-y: auto;
  padding-top: 8px;
  position: relative;

  .refund-details-drawer-header {
    background: var(--rms-v2-surface);
    border-bottom: 1px solid var(--rms-v2-border-soft);
    padding: 18px 20px;
  }

  .refund-details-drawer-header p {
    color: var(--rms-v2-text-title);
    font-size: 14px;
    font-weight: 800;
    margin: 0;
  }

  .refund-details-upi-form {
    background: var(--rms-v2-surface);
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 12px;
    padding: 16px;
  }

  .refund-details-submit {
    align-self: center;
    border-radius: ${(props) => (props.rounded ? "10px" : "0px")} !important;
    cursor: pointer;
    height: 40px;
    margin: 18px auto 0 !important;
    min-height: 40px;
    padding: 0 18px !important;
    text-transform: capitalize !important;
  }
`;
